import { render, staticRenderFns } from "./MovimientosTarimaModalComponent.vue?vue&type=template&id=4071e238&"
import script from "./MovimientosTarimaModalComponent.vue?vue&type=script&lang=js&"
export * from "./MovimientosTarimaModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports